import { createSelector } from 'reselect';
import { RootState } from 'typesafe-actions';

type DyState = {
  isContentChanged: boolean;
  isGfCampaignLoaded: boolean;
};

const dyRootSelector = (state: RootState): DyState => state.dy;

export const getIsGfCampaignLoaded = createSelector(
  dyRootSelector,
  ({ isGfCampaignLoaded }: DyState) => isGfCampaignLoaded
);

export const getIsContentChanged = createSelector(
  dyRootSelector,
  ({ isContentChanged }: DyState) => isContentChanged
);
